import { render, staticRenderFns } from "./ModuleIcon.vue?vue&type=template&id=300e5876&"
import script from "./ModuleIcon.vue?vue&type=script&lang=js&"
export * from "./ModuleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports